import React, { Suspense } from 'react';

const LazyCartButton = React.lazy(() => import('../containers/CartButton'));

function CartButton() {
    return (
        <Suspense fallback={(<></>)}>
            <LazyCartButton />
        </Suspense>
    );
}

export { CartButton };
